// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import { TableComponent, TableColumn } from 'vue-table-component'
import App from './App'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import VuesticPlugin from 'src/components/vuestic-components/vuestic-components-plugin'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueGoodTable from 'vue-good-table'
import ToggleButton from 'vue-js-toggle-button'
import Tooltip from 'vue-directive-tooltip'
import VueGtm from 'vue-gtm'
import VueMoment from 'vue-moment'


Vue.component('table-component', TableComponent)
Vue.component('table-column', TableColumn)

Vue.use(VueAxios, axios)
Vue.use(VuesticPlugin)
Vue.use(BootstrapVue)
Vue.use(VueLodash, lodash)
Vue.use(VueGoodTable)
Vue.use(ToggleButton)
Vue.use(Tooltip)
Vue.use(VueMoment)
Vue.use(VueGtm, {
  appName: 'Keylogs', // Mandatory
  appVersion: '1.0', // Mandatory
  // trackingId: 'UA-112018279-2',
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // If router, you can exclude some routes name (case insensitive) (optional)
})

// Global Axios Settings
axios.defaults.baseURL = 'http://localhost:3245/api/'
if (process.env.NODE_ENV === 'production') axios.defaults.baseURL = 'https://app.keylogs.io/api/'
if (process.env.NODE_ENV === 'staging') axios.defaults.baseURL = 'https://keylogs.staging.webmarken.com/api/'

axios.defaults.headers.get['Auth'] = localStorage.getItem('token') // for POST requests
axios.defaults.headers.post['Auth'] = localStorage.getItem('token')
axios.defaults.headers.delete['Auth'] = localStorage.getItem('token')
axios.defaults.headers.put['Auth'] = localStorage.getItem('token')

axios.interceptors.response.use(response => { // intercept the global error
  return response
}, function (error) {
  let originalRequest = error.config
  console.log(error)
  // if the error is 401 and Auth String is present (so this does not triggered when still logged out)
  if (error.response.status === 401 && typeof originalRequest.headers.Auth === 'string') {
    console.log('user unauthorized - log out')
    store.dispatch('logout')
  }
    // Do something with response error
  return Promise.reject(error)
})



// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})

sync(store, router)

let mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    store.dispatch('toggleSidebar', false)
  } else {
    store.dispatch('toggleSidebar', false)
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  // reroute if not authenticated
  if (to.name === 'Login') next()
  else {
    try {
      var subscription = JSON.parse(localStorage.getItem('subscription'))
      store.dispatch('setSubscription', subscription || false)
    } catch (e) {
      console.log(e)
      store.dispatch('setSubscription', false)
    }

    store.dispatch('isLoggedIn').then(response => {
      if (response) {
        next()
      } else {
        next({ path: '/login' })
      }
    }, error => {
      console.log(error)
    })
  }
})

router.afterEach((to, from) => {
  mediaHandler()
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js